var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24.5 27.3",
    style: {
      enableBackground: "new 0 0 24.5 27.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1039_1_",
    transform: "translate(411.598 755.957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2_1_",
    className: "st0",
    cx: -399.3,
    cy: -748.1,
    r: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503_1_",
    className: "st0",
    d: "M-410.8-729.4c0-6.3,5.1-11.5,11.5-11.5l0,0c6.4,0,11.5,5.2,11.5,11.5l0,0H-410.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.634d70bb048726ace904e2dbca0fecf3.svg";
export { ForwardRef as ReactComponent };